import SystemAlert, { alertClasses } from "@mui/material/Alert";
import { styled } from "../../styles/index.js";
import { rootShouldForwardProp } from "@mui/material/styles/styled";
const AlertRoot = styled(SystemAlert, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "TrueAlert",
  slot: "Root"
})(({ theme }) => {
  const { body1: font } = theme.typography || { body1: {} };
  const { body1: fontMobile } = theme.typography.mobile || { body1: {} };
  return {
    alignItems: "center",
    padding: theme.spacing(2, 3),
    ...font,
    [theme.breakpoints.down("md")]: {
      ...fontMobile
    },
    "& .MuiAlert-action": {
      padding: 0,
      paddingLeft: theme.spacing(2)
    },
    "& .MuiIconButton-label .MuiSvgIcon-root": {
      fontSize: "1rem"
    },
    [`.${alertClasses.icon}`]: {
      color: "inherit",
      margin: 0
    },
    [`.${alertClasses.message}`]: {
      marginLeft: theme.spacing(2)
    },
    [`&.${alertClasses.standardSuccess}`]: {
      background: theme.palette.success.light,
      color: theme.palette.success.dark
    },
    [`&.${alertClasses.standardWarning}`]: {
      background: theme.palette.warning.light,
      color: theme.palette.warning.dark
    },
    [`&.${alertClasses.standardInfo}`]: {
      background: theme.palette.secondary.light,
      color: theme.palette.text.high
    },
    [`&.${alertClasses.standardError}`]: {
      background: theme.palette.error.light,
      color: theme.palette.error.dark
    }
  };
});
const AlertNegativeRoot = styled(AlertRoot, {
  shouldForwardProp: (prop) => rootShouldForwardProp(prop) || prop === "classes",
  name: "TrueAlertNegativeRoot",
  slot: "Root"
})(({ theme }) => {
  return {
    [`&.${alertClasses.standardError}`]: {
      /** TODO: update @truepay-tokens to version ^2.44.0 to use theme.palette.brandSupport?.[5] */
      backgroundColor: "rgba(255, 236, 246, 1)",
      color: theme.palette.brandSupport?.[3]
    }
  };
});
export {
  AlertNegativeRoot,
  AlertRoot
};
//# sourceMappingURL=alert.styles.js.map
